<script setup>
import {computed} from 'vue';
import {QuillEditor} from '@rafaeljunioxavier/vue-quill-fix';
import '@rafaeljunioxavier/vue-quill-fix/dist/vue-quill.snow.css';

const props = defineProps({
  modelValue: {
    type: String,
    default: '<p>Comece a digitar aqui...</p>'
  }
});

const emit = defineEmits(['update:modelValue', 'contentChange']);

// Two-way binding for v-model
const editorContent = computed({
  get: () => props.modelValue,
  set: (val) => {
    emit('update:modelValue', val);
    emit('contentChange', val);
  }
});

const selectLocalImage = () => {
  const input = document.createElement('input');
  input.setAttribute('type', 'file');
  input.setAttribute('accept', 'image/*');
  input.click();

  input.onchange = async () => {
    const file = input.files?.[0];
    if (file) {
      const range = quillInstance.getSelection();
      const cursorPosition = range ? range.index : 0;

      quillInstance.insertEmbed(cursorPosition, 'image', 'carregando...');

      try {
        const imageUrl = await uploadImage(file);
        quillInstance.deleteText(cursorPosition, 1);
        quillInstance.insertEmbed(cursorPosition, 'image', imageUrl);
        quillInstance.setSelection(cursorPosition + 1);
        editorContent.value = quillInstance.root.innerHTML;
      } catch (error) {
        console.error('Erro no upload da imagem:', error);
        quillInstance.deleteText(cursorPosition, 1);
        alert('Falha ao fazer upload da imagem.');
      }
    }
  };
};

// Editor configuration
const editorOptions = {
  placeholder: 'Digite algo...',
  theme: 'snow',
  modules: {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],
        [{'header': 1}, {'header': 2}],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        [{'indent': '-1'}, {'indent': '+1'}],
        ['link', 'image'],
        [{'color': []}, {'background': []}],
        ['clean']
      ],
      handlers: {
        image: selectLocalImage
      }
    }
  }
};

let quillInstance = null;

const onReady = (quill) => {
  quillInstance = quill;
  quillInstance.root.innerHTML = props.modelValue
};

async function upload(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
}

async function uploadImage(file) {
  try {
    return  await upload(file);
  } catch (e) {
    Alert.error('Não foi possível inserir a imagem');
    throw e;
  }
}
</script>

<template>
  <span>
    <client-only>
      <QuillEditor
          v-model:content="editorContent"
          contentType="html"
          :options="editorOptions"
          @ready="onReady"
          style="height: 350px"
      />
    </client-only>
  </span>
</template>

<style scoped>
:deep(.ql-container) {
  font-size: 16px;
}

:deep(.ql-editor) {
  min-height: 300px;
}
</style>
